import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Typography from '@sharedComponents/Typography';
import cx from 'classnames';

import * as style from './style.module.css';

/**
 * One option of a single choice, shown as a card: an icon, a title and a description. Several cards
 * placed in a `role="radiogroup"` container behave like radio buttons without their visual: the
 * selected one is highlighted, and selecting another one is up to the parent.
 */
const ChoiceCard = ({ icon = null, title = '', description = '', selected = false, onSelect = () => {} }) => (
    <button
        type="button"
        role="radio"
        aria-checked={selected}
        className={cx(style.card, { [style.selected]: selected })}
        onClick={onSelect}
    >
        <span className={style.header}>
            {icon && <FontAwesomeIcon icon={icon} className={style.icon} />}
            <Typography span fontSize="m" fontWeight="bold" color="neutral-primary">
                {title}
            </Typography>
        </span>
        {description && (
            <Typography span fontSize="s" color="neutral-primary">
                {description}
            </Typography>
        )}
    </button>
);

export default ChoiceCard;
